module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Shield-disabled-9d898c285ecf912ed5a560faa9cc9d0d.svg";